import React from "react";
import styled from "styled-components";

export const GourmetoO = ({ className, tone = "light" }) => (
  <OImg
    className={className}
    src={tone === "dark" ? "/brand/o-on-dark.png" : "/brand/o-on-light.png"}
    alt=""
    aria-hidden="true"
  />
);

export const GourmetoWordmark = ({ size = 32, as: Tag = "span" }) => (
  <Wordmark as={Tag} $size={size} aria-label="Mygourmeto">
    <img className="wm-light" src="/brand/wordmark-on-light.png?v=5" alt="" />
    <img className="wm-dark" src="/brand/wordmark-on-dark.png?v=5" alt="" />
  </Wordmark>
);

export const GourmetoMark = ({ size = 36, title = "gourmeto" }) => (
  <Mark src="/brand/g.png" width={size} height={size} alt={title} />
);

const Wordmark = styled.span`
  display: inline-flex;
  align-items: center;
  height: ${(p) => p.$size}px;
  line-height: 0;

  @media (max-width: 1023px) {
    height: ${(p) => Math.min(26, p.$size)}px;
  }

  img {
    height: 100%;
    width: auto;
    display: none;
    object-fit: contain;
  }

  .wm-light {
    display: block;
  }

  .wm-dark {
    display: none;
  }

  .theme-dark & {
    .wm-light {
      display: none;
    }
    .wm-dark {
      display: block;
    }
  }
`;

const OImg = styled.img`
  height: 1.28em;
  width: auto;
  display: block;
`;

const Mark = styled.img`
  display: block;
  flex-shrink: 0;
  border-radius: 14px;
  object-fit: cover;
`;

export default GourmetoWordmark;
